import { NodeType } from "app/lib/pipeline";
import { NodeTypes } from "@xyflow/react";

import { default as CommandStepNode } from "./CommandStepNode";
import { default as WaitStepNode } from "./WaitStepNode";
import { default as InputStepNode } from "./InputStepNode";
import { default as RootNode } from "./RootNode";
import { default as GroupStepNode } from "./GroupStepNode";
import { default as TriggerStepNode } from "./TriggerStepNode";

/**
 * A map of node types to their corresponding React components.
 */
export const nodeTypes: NodeTypes = {
  [NodeType.Root]: RootNode,
  [NodeType.Command]: CommandStepNode,
  [NodeType.Input]: InputStepNode,
  [NodeType.Wait]: WaitStepNode,
  [NodeType.Block]: InputStepNode,
  [NodeType.Group]: GroupStepNode,
  [NodeType.Trigger]: TriggerStepNode,
};
